<template>
	<detail-row-wrapper :save-function="submit" :cancel-function="cancel">
		<div class="contents-wrapper">
			<div class="main-contents">
				<div class="flex-container flex-align-left flex-direction-column">
					<detail-row-component
						title="제목"
						:disable-line="true"
						:inner-vertical="true"
					>
						<div class="title-color-wrapper">
							<layout-input
								v-model="editable.title"
								:regex="regex(1, 100).ko_en_num"
								placeholder="제목을 입력해주세요."
							/>
						</div>
					</detail-row-component>

					<detail-row-component title="상단 이미지" innerVertical>
						<layout-image-selector
							v-model="editable.imgTop"
							:index="`image_top${rowData.id}`"
							:on-image-out-of-size="onImageOutOfSize"
						/>
						<layout-info
							title="* 싱글 큐레이션 이미지 사이즈 : 1080 X 540"
							infoType="warn"
						/>
						<layout-info
							title="* 멀티 큐레이션 이미지 사이즈 : 1080 X 662"
							infoType="warn"
						/>
						<layout-info
							title="* 배너 이미지 사이즈 : 1080 X (540 ~ 860)"
							infoType="warn"
						/>
					</detail-row-component>

					<detail-row-component title="하단 이미지">
						<layout-image-selector
							v-model="editable.imgBottom"
							:index="`image_bottom${rowData.id}`"
							:on-image-out-of-size="onImageOutOfSize"
						/>
					</detail-row-component>

					<detail-row-component title="기간 사용">
						<layout-checkbox v-model="editable.isAutoStart" />
					</detail-row-component>

					<detail-row-component title="시작 날짜" v-show="editable.isAutoStart">
						<layout-date-picker
							v-model="editable.beginAt"
							place-holder="시작 날짜를 선택해주세요."
						/>
					</detail-row-component>

					<detail-row-component title="종료 날짜" v-show="editable.isAutoStart">
						<layout-date-picker
							v-model="editable.expireAt"
							place-holder="종료 날짜를 선택해주세요."
						/>
					</detail-row-component>

					<detail-row-component title="타입">
						<layout-radio-button
							v-model="editable.type"
							:name="`type${rowIndex}`"
							:select-list="['single', 'banner']"
							:view-list="['싱글', '배너']"
						/>
						<!-- <layout-radio-button
							v-model="editable.type"
							:name="`type${rowIndex}`"
							:select-list="['multiple', 'single', 'banner']"
							:view-list="['멀티', '싱글', '배너']"
						/> -->
					</detail-row-component>

					<detail-row-component
						title="정렬"
						v-show="isSingle"
						:disable-line="true"
					>
						<layout-radio-button
							v-model="editable.alignment"
							:name="`alignment${rowIndex}`"
							:select-list="[0, 1]"
							:view-list="['좌측', '우측']"
						/>
					</detail-row-component>

					<detail-row-component
						title="배너타입"
						v-show="isBanner"
						:disable-line="true"
					>
						<layout-radio-button
							v-model="editable.bannerType"
							:name="`bannerType${rowIndex}`"
							:select-list="['URL', 'wine']"
							:view-list="['URL', '와인']"
						/>
					</detail-row-component>

					<detail-row-component
						title="URL"
						v-show="isURL && isBanner"
						:inner-vertical="true"
					>
						<layout-input
							v-model="editable.link"
							placeholder="URL을 입력해주세요 (optional)"
						/>

						<layout-info
							title="* URL에 http:// 혹은 https://를 포함시켜주세요"
						/>
					</detail-row-component>

					<detail-row-component
						title="큐레이션 와인 목록"
						:inner-vertical="true"
						v-show="isMultiple"
					>
						<detail-row-component
							title
							:outer-vertical="true"
							:inner-vertical="true"
							:disable-line="true"
						>
							<wine-list-view v-model="editable.winesInCuration" />
						</detail-row-component>
					</detail-row-component>

					<detail-row-component
						title="큐레이션 와인"
						v-if="isSingle || (isBanner && !isURL)"
					>
						<wine-view v-model="editable.wine" />
					</detail-row-component>

					<detail-row-component title="발행">
						<layout-switch-button v-model="editable.isEnabled" />
					</detail-row-component>
				</div>
			</div>

			<!--<preview :row-index="rowIndex" :editable="editable"/>-->
		</div>
	</detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from "@/utils/utils";

import LayoutInput from "@/spa/components/LayoutInput";
import LayoutColorSelector from "@/spa/components/LayoutColorSelector";
import LayoutDatePicker from "@/spa/components/LayoutDatePicker";
import LayoutInfo from "@/spa/components/LayoutInfo";
import LayoutImageSelector from "@/spa/components/LayoutImageSelector";
import LayoutCheckbox from "@/spa/components/LayoutCheckbox";
import LayoutSwitchButton from "@/spa/components/LayoutSwitchButton";
import LayoutRadioButton from "@/spa/components/LayoutRadioButton";

import DetailRowWrapper from "@/spa/components/detail-row/DetailRowWrapper";
import DetailRowComponent from "@/spa/components/detail-row/DetailRowComponent";

import WineListView from "./curation-wine-list/WineListView";
import WineView from "./curation-wine-list/WineView";

// import Preview from './preview/PreviewMultipleWineStyle';

export default {
	name: "CurtationEditor",
	components: {
		DetailRowComponent,
		DetailRowWrapper,

		WineListView,
		WineView,

		LayoutImageSelector,
		LayoutColorSelector,
		LayoutInput,
		LayoutDatePicker,
		LayoutSwitchButton,
		LayoutCheckbox,
		LayoutInfo,
		LayoutRadioButton

		// Preview,
	},
	props: {
		rowData: {
			type: Object,
			required: true
		},
		rowIndex: {
			type: Number
		}
	},
	computed: {
		isSingle() {
			return this.editable.type === "single";
		},

		isMultiple() {
			return this.editable.type === "multiple";
		},

		isBanner() {
			return this.editable.type === "banner";
		},

		isURL() {
			return this.editable.bannerType === "URL";
		}
	},
	methods: {
		regex(min = 0, max = 0) {
			return regex(min, max);
		},

		onImageOutOfSize() {
			this.$toast("사이즈가 4메가가 넘습니다.");
		},

		async uploadImage(image) {
			if (!image) return null;
			if (typeof image === "string") return image;
			try {
				const result = await this.$store.dispatch("imageUploadS3", {
					name: "groups",
					image
				});
				console.log("result.response", result.response);
				if (!result.response) return image;
				this.$toast(result.message);
				this.$toast("데이터베이스 업로드 작업중 입니다. 조금만 기다려주세요.");

				return result.response.location;
			} catch (e) {
				console.log("e", e.message);
				return null;
			}
		},

		formalizeCuration(editable) {
			const curation = editable;

			if (this.isBanner && this.isURL) {
				curation.winesInCuration = [];
			} else if (this.isSingle || (this.isBanner && !this.isURL)) {
				curation.winesInCuration = [
					{
						id: curation.wine.id,

						group_id: curation.id,
						wine_id: curation.wine.wine_id,
						short_wine_name: curation.wine.short_wine_name,
						curation_dsc: curation.wine.curation_dsc,
						order_number: 0
					}
				];
			} else if (this.isMultiple) {
				curation.winesInCuration = curation.winesInCuration.map(
					(curationWine, orderIndex) => ({
						id: curationWine.id,

						group_id: curation.id,
						wine_id: curationWine.wine_id,
						short_wine_name: curationWine.short_wine_name,
						curation_dsc: curationWine.curation_dsc,
						order_number: orderIndex
					})
				);
			}

			return curation;
		},

		async submit() {
			this.editable.id = this.rowData.id;
			this.editable.imgTop = await this.uploadImage(this.editable.imgTop);
			this.editable.imgBottom = await this.uploadImage(this.editable.imgBottom);

			this.editable = this.formalizeCuration(this.editable);

			const validateResult = multipleValidate([
				validate({
					message: "제목",
					target: this.editable.title,
					regex: this.regex(1, 100).ko_en_num
				})
			]);

			if (this.editable.isEnabled && validateResult.flag) {
				this.$toast(validateResult.message);
				return;
			}

			const result = await this.$store.dispatch(
				"updateCuration",
				this.editable
			);

			if (result.response) {
				this.$table.updateField();
			}

			this.$toast(result.message);
		},

		cancel() {
			this.$table.updateField();
		}
	},
	data() {
		return {
			editable: {
				orderIndex: this.rowData.order_index,

				type: this.rowData.type || "multiple",
				link: this.rowData.link,
				alignment: this.rowData.alignment || 0,
				bannerType: !this.rowData.wines_in_curation
					? "URL"
					: this.rowData.wines_in_curation.length > 0
					? "wine"
					: "URL",

				title: this.rowData.title,

				imgTop: this.rowData.img_top,

				isAutoStart: this.rowData.is_auto_start,
				beginAt: this.rowData.begin_at,
				expireAt: this.rowData.expire_at,

				winesInCuration: this.rowData.wines_in_curation || [],
				wine: this.rowData.wines_in_curation[0] || {
					id: 0,
					wine_id: null,
					short_wine_name: "",
					curation_dsc: "",
					order_number: 0
				},

				isEnabled: this.rowData.is_enabled
			}
		};
	}
};
</script>

<style lang="scss" scoped>
.contents-wrapper {
	position: relative;
	min-height: 600px;

	display: flex;
	justify-content: flex-start;
	align-content: flex-start;
	align-items: flex-start;

	flex-direction: row;

	.main-contents {
		position: relative;
		width: 60%;

		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		align-content: flex-start;

		.title-color-wrapper {
			display: flex;
			flex-direction: row;
		}

		.left-blank {
			margin-left: 20px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/curation/detail-row/CurationEditor.vue